import { render, staticRenderFns } from "./SaleLayout.vue?vue&type=template&id=c23d91bc"
import script from "./SaleLayout.vue?vue&type=script&lang=js"
export * from "./SaleLayout.vue?vue&type=script&lang=js"
import style0 from "./SaleLayout.vue?vue&type=style&index=0&id=c23d91bc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports